import CityPage from "../CityPage";

export default function ClarendonHills() {
  return <CityPage slug="clarendon-hill" />;
}
